// components/MenuServices.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const MenuServices = () => {
  const location = useLocation();
  
  const menuItems = [
    { path: "/LifeStyleEvasion", label: "Lifestyle / Évasion" },
    { path: "/Bien-etre", label: "Bien-Être" },
    { path: "/Conciergerie-privee", label: "Conciergerie Privée" },
    { path: "/Culture-tourisme", label: "Culture / Tourisme" },
    { path: "/Formalites-aeroportuaire", label: "Formalités Aéroportuaires" },
    { path: "/Lounges", label: "Lounge VIP & Espace de Travail" }
  ];

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.5,
        ease: "easeOut"
      }
    }),
    hover: {
      scale: 1.05,
      x: 10,
      backgroundColor: "rgba(255, 152, 0, 0.1)",
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 10
      }
    }
  };

  const activeIndicator = {
    initial: { scale: 0 },
    animate: { 
      scale: 1,
      transition: { type: "spring", stiffness: 300, damping: 20 }
    }
  };

  return (
    <div className="widget glass-card">
      <motion.h3 
        className="widget-title gradient-text"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Nos Solutions
      </motion.h3>
      <ul className="nav service-menu">
        {menuItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <motion.li 
              key={item.path}
              className={isActive ? 'active' : ''}
              custom={index}
              variants={itemVariants}
              initial="hidden"
              animate="visible"
              whileHover="hover"
            >
              <Link to={item.path} className="menu-link">
                {isActive && (
                  <motion.span 
                    className="active-indicator"
                    layoutId="activeIndicator"
                    variants={activeIndicator}
                    initial="initial"
                    animate="animate"
                  />
                )}
                <span className="link-text">{item.label}</span>
                <motion.div 
                  className="hover-underline"
                  initial={{ scaleX: 0 }}
                  whileHover={{ scaleX: 1 }}
                  transition={{ duration: 0.3 }}
                />
              </Link>
            </motion.li>
          );
        })}
      </ul>
    </div>
  );
};

export default MenuServices;